import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
var CustomItemRow = {};
CustomItemRow.displayName = displayNames.SORT_BY_DRAG_LIST_CUSTOM_ITEM_ROW;
CustomItemRow.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  content: PropTypes.element,
  contentBefore: PropTypes.element,
  contentAfter: PropTypes.element,
  customAction: PropTypes.element,
  disabled: PropTypes.bool,
  disableEditing: PropTypes.bool,
  removable: PropTypes.bool,
  draggable: PropTypes.bool,
  dragHandleEnabled: PropTypes.bool,
  dragHandleTooltipContent: PropTypes.string,
  isDefault: PropTypes.bool,
  isSelected: PropTypes.bool,
  isContextMenuOpen: PropTypes.bool,
  onContextMenuToggle: PropTypes.func,
  contextMenuAlignment: PropTypes.string,
  contextMenuDirection: PropTypes.string,
  dynamicItemsGetter: PropTypes.func,
  skin: PropTypes.oneOf(['standard', 'general']),
  isHidden: PropTypes.bool
};
CustomItemRow.defaultProps = {
  disabled: false
};
export default compose(CustomItemRow);